<div class="collab-panel">
  <div class="collab-upload">
    <label class="btn btn-outline-primary btn-sm mb-0" [class.disabled]="uploading">
      <i class="fas" [class.fa-upload]="!uploading" [class.fa-spinner]="uploading" [class.fa-spin]="uploading"></i>
      {{ uploading ? 'Enviando...' : 'Anexar foto ou documento' }}
      <input type="file" hidden [disabled]="uploading" (change)="onFileSelected($event)" />
    </label>
    <small class="text-muted">Até 25 MB por arquivo.</small>
  </div>

  <p class="collab-loading" *ngIf="loading">
    <i class="fas fa-spinner fa-spin"></i> Carregando evidências...
  </p>

  <p class="collab-empty" *ngIf="!loading && evidencias.length === 0">
    Nenhuma evidência anexada a este orçamento.
  </p>

  <ng-container *ngIf="!loading">
    <ng-container *ngIf="groupByLine">
      <div *ngFor="let group of groupedLineEvidences()" class="evidence-group">
        <h6 class="collab-subtitle"><i class="fas fa-link"></i> {{ group.title }} ({{ group.items.length }})</h6>
        <div class="collab-gallery">
          <figure class="collab-photo" *ngFor="let e of group.items">
            <a *ngIf="isImage(e); else groupedDoc" [href]="e.downloadUrl" target="_blank" rel="noopener">
              <img [src]="e.downloadUrl" [alt]="e.fileName" loading="lazy" />
            </a>
            <ng-template #groupedDoc>
              <a class="line-doc-link" [href]="e.downloadUrl" target="_blank" rel="noopener">
                <i class="fas fa-file"></i> {{ e.fileName }}
              </a>
            </ng-template>
            <figcaption>
              <span class="collab-photo__name" [title]="e.fileName">{{ e.fileName }}</span>
            </figcaption>
          </figure>
        </div>
      </div>

      <div *ngIf="generalEvidencias.length">
        <h6 class="collab-subtitle"><i class="fas fa-folder-open"></i> Gerais ({{ generalEvidencias.length }})</h6>
        <div class="collab-gallery">
          <figure class="collab-photo" *ngFor="let e of generalEvidencias">
            <a *ngIf="isImage(e); else generalGroupedDoc" [href]="e.downloadUrl" target="_blank" rel="noopener">
              <img [src]="e.downloadUrl" [alt]="e.fileName" loading="lazy" />
            </a>
            <ng-template #generalGroupedDoc>
              <a class="line-doc-link" [href]="e.downloadUrl" target="_blank" rel="noopener">
                <i class="fas fa-file"></i> {{ e.fileName }}
              </a>
            </ng-template>
            <figcaption>
              <span class="collab-photo__name" [title]="e.fileName">{{ e.fileName }}</span>
              <span class="collab-when">{{ e.autor }} · {{ e.criadoEm | brDate:'dd/MM/yyyy HH:mm' }}</span>
            </figcaption>
          </figure>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!groupByLine">
    <div *ngIf="fotos.length">
      <h6 class="collab-subtitle"><i class="fas fa-image"></i> Fotos ({{ fotos.length }})</h6>
      <div class="collab-gallery">
        <figure class="collab-photo" *ngFor="let e of fotos">
          <a [href]="e.downloadUrl" target="_blank" rel="noopener">
            <img [src]="e.downloadUrl" [alt]="e.fileName" loading="lazy" />
          </a>
          <figcaption>
            <span class="collab-photo__name" [title]="e.fileName">{{ e.fileName }}</span>
            <span class="collab-when">
              {{ origemLabel(e) }} · {{ e.autor }} · {{ e.criadoEm | brDate:'dd/MM/yyyy' }}
            </span>
            <button type="button" class="btn btn-link btn-sm text-danger p-0" (click)="remove(e)">
              <i class="fas fa-trash"></i> Remover
            </button>
          </figcaption>
        </figure>
      </div>
    </div>

    <div *ngIf="documentos.length">
      <h6 class="collab-subtitle"><i class="fas fa-file-alt"></i> Documentos ({{ documentos.length }})</h6>
      <ul class="collab-docs">
        <li *ngFor="let e of documentos">
          <i class="fas fa-file"></i>
          <div class="collab-docs__info">
            <a [href]="e.downloadUrl" target="_blank" rel="noopener">{{ e.fileName }}</a>
            <span class="collab-when">
              {{ e.tipo }} · {{ formatSize(e.fileSize) }} · {{ origemLabel(e) }} · {{ e.autor }}
              · {{ e.criadoEm | brDate:'dd/MM/yyyy HH:mm' }}
            </span>
          </div>
          <button type="button" class="btn btn-link btn-sm text-danger" title="Remover" (click)="remove(e)">
            <i class="fas fa-trash"></i>
          </button>
        </li>
      </ul>
    </div>
    </ng-container>
  </ng-container>
</div>
